export enum TransactionHistoryStatus {
  Success = 'SUCCESS',
  Pending = 'PENDING',
  Error = 'ERROR',
  Failed = 'FAILED',
  Canceled = 'CANCEL',
  Processing = 'PROCESSING',
  PAID = 'PAID',
  NEW = 'NEW',
}
export enum TransactionHistoryType {
  Topup = 'Topup',
  Recharge = 'Recharge',
  LocalRecharge = 'LocalRecharge',
  Commission = 'Commission',
  Refund = 'Refund',
  Reward = 'Reward',
  RechargeAsimPortal = 'RechargeAsimPortal',
  Active = 'Active',
  ChangeSim = 'ChangeSim',
  Datacode = 'Datacode',
  RegisterPackage = 'RegisterPackage',
  ChangePackage = 'ChangePackage',
  Excess = 'Excess',
  Mistake = 'Mistake',
  Paid = 'Paid',
  PaidTopup = 'PaidTopup',
  CancelPackage = 'CancelPackage',
  InitiatePackage = 'InitiatePackage',
  EnterpriseTopup = 'EnterpriseTopup',
}
